var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Alert, Snackbar } from '@mui/material';
var EventSnackbarContext = React.createContext(null);
var DEFAULT_AUTO_HIDE_MS = 4500;
export var EventSnackbarProvider = function (_a) {
    var _b, _c;
    var children = _a.children;
    var _d = React.useState(false), open = _d[0], setOpen = _d[1];
    var _e = React.useState(null), currentEvent = _e[0], setCurrentEvent = _e[1];
    var _f = React.useState([]), queue = _f[0], setQueue = _f[1];
    var showEvent = React.useCallback(function (payload) {
        var _a, _b;
        var normalizedPayload = {
            message: payload.message,
            severity: (_a = payload.severity) !== null && _a !== void 0 ? _a : 'info',
            autoHideDuration: (_b = payload.autoHideDuration) !== null && _b !== void 0 ? _b : DEFAULT_AUTO_HIDE_MS,
        };
        if (!open && !currentEvent) {
            setCurrentEvent(normalizedPayload);
            setOpen(true);
            return;
        }
        setQueue(function (currentQueue) { return __spreadArray(__spreadArray([], currentQueue, true), [normalizedPayload], false); });
    }, [open, currentEvent]);
    var handleClose = function (_event, reason) {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    var handleExited = function () {
        if (queue.length > 0) {
            var next = queue[0], remaining = queue.slice(1);
            setQueue(remaining);
            setCurrentEvent(next);
            setOpen(true);
            return;
        }
        setCurrentEvent(null);
    };
    return (_jsxs(EventSnackbarContext.Provider, { value: { showEvent: showEvent }, children: [children, _jsx(Snackbar, { open: open, autoHideDuration: (_b = currentEvent === null || currentEvent === void 0 ? void 0 : currentEvent.autoHideDuration) !== null && _b !== void 0 ? _b : DEFAULT_AUTO_HIDE_MS, onClose: handleClose, anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, slotProps: {
                    transition: {
                        onExited: handleExited,
                    },
                }, children: _jsx(Alert, { severity: ((_c = currentEvent === null || currentEvent === void 0 ? void 0 : currentEvent.severity) !== null && _c !== void 0 ? _c : 'info'), onClose: handleClose, variant: 'filled', sx: { width: '100%' }, children: currentEvent === null || currentEvent === void 0 ? void 0 : currentEvent.message }) })] }));
};
export var useEventSnackbar = function () {
    var ctx = React.useContext(EventSnackbarContext);
    if (!ctx) {
        throw new Error('useEventSnackbar must be used within an EventSnackbarProvider');
    }
    return ctx;
};
